import deviceSettingsSagas from './device-settings';
import messagesSagas from './messages';

export default [
  ...deviceSettingsSagas,
  ...messagesSagas,
];
